import { motion } from "framer-motion";
import { ArrowRight, Search } from "lucide-react";
import { Button } from "@/components/ui/button";

export const Hero = ({ settings }) => {
  return (
    <section id="top" className="relative overflow-hidden bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24 lg:py-28 grid lg:grid-cols-12 gap-12 items-center">
        <motion.div className="lg:col-span-6" initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <p className="text-xs sm:text-sm uppercase tracking-[0.2em] font-bold text-blue-600 mb-5" data-testid="hero-label">
            Van & Crew Delivery Service · Multi-Sector · Bristol, UK
          </p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-bold text-slate-900 leading-[1.05]" data-testid="hero-headline">
            {settings.hero_headline}
          </h1>
          <p className="mt-6 text-base sm:text-lg text-slate-600 leading-relaxed max-w-xl" data-testid="hero-subtext">
            {settings.hero_subtext}
          </p>
          <div className="mt-9 flex flex-col sm:flex-row gap-4">
            <Button asChild size="lg" data-testid="hero-cta-book-crew" className="bg-blue-600 hover:bg-blue-700 text-white rounded-md h-12 px-7 text-base">
              <a href="#hire-us">Book a Van & Crew <ArrowRight className="ml-2 h-4 w-4" /></a>
            </Button>
            <Button asChild size="lg" variant="outline" data-testid="hero-cta-join-crew"
              className="border-slate-300 text-slate-900 hover:bg-slate-50 rounded-md h-12 px-7 text-base">
              <a href="#jobs"><Search className="mr-2 h-4 w-4" /> Join our crew</a>
            </Button>
          </div>
          <div className="mt-12 grid grid-cols-3 gap-6 max-w-md" data-testid="hero-stats">
            {[["10+", "Years experience"], ["500+", "Deliveries completed"], ["24h", "Same-day dispatch"]].map(([num, label]) => (
              <div key={label}>
                <p className="text-2xl sm:text-3xl font-bold text-slate-900 tracking-tight">{num}</p>
                <p className="text-xs sm:text-sm text-slate-500 mt-1">{label}</p>
              </div>
            ))}
          </div>
        </motion.div>
        <motion.div className="lg:col-span-6 relative" initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.15 }}>
          <div className="absolute -top-6 -right-6 w-40 h-40 bg-cyan-100 rounded-lg hidden lg:block" aria-hidden="true" />
          <div className="absolute -bottom-6 -left-6 w-28 h-28 bg-blue-600 rounded-lg hidden lg:block" aria-hidden="true" />
          <img
            src="/assets/box-van.jpg"
            alt="PRGL box van at a distribution depot"
            className="relative rounded-lg shadow-[0_8px_24px_rgba(15,23,42,0.12)] w-full h-[320px] sm:h-[440px] object-cover"
            data-testid="hero-image"
          />
        </motion.div>
      </div>
    </section>
  );
};
